/* eslint-disable max-lines */

import i18next from 'i18next';

import { ISO_COUNTRY } from '~constants/environment';
import { CLIENT_PAGES } from '~constants/pages';

import styles from './styles.module.scss';

const titleGroupStyle = 'subtitle-small text-white m-bottom-3';

const groupStyle = `column full-height middle m-right-12 ${styles.groupLinks}`;
const linkStyle = `text-base text-white ${styles.linkFooter}`;

export const FOOTER_BASE_ITEMS = {
  titleGroup: '',
  titleGroupStyle,
  groupStyle
};

export const FIRST_PAGE = 1;

export const PROFILE_MENU_BASE_ITEMS = {
  titleGroup: '',
  titleGroupStyle
};

export const MERCAT_TERMS_AND_CONDITIONS_PAGE = {
  title: CLIENT_PAGES.MERCAT_TERMS_AND_CONDITIONS.title,
  relativeUrl: CLIENT_PAGES.MERCAT_TERMS_AND_CONDITIONS.path,
  published: true
};

const FOOTER_LINKS_CL = [
  {
    ...FOOTER_BASE_ITEMS,
    links: [
      {
        text: i18next.t('Footer:dispatchZone'),
        to: CLIENT_PAGES.UNAVAILABLE.path,
        style: linkStyle
      },
      {
        text: i18next.t('Footer:contact'),
        to: CLIENT_PAGES.UNAVAILABLE.path,
        style: linkStyle
      },
      {
        text: i18next.t('Footer:faq'),
        href: CLIENT_PAGES.UNAVAILABLE.path,
        style: linkStyle
      }
    ]
  },
  {
    ...FOOTER_BASE_ITEMS,
    links: [
      {
        text: i18next.t('Footer:myAccount'),
        to: CLIENT_PAGES.UNAVAILABLE.path,
        style: linkStyle
      },
      {
        text: i18next.t('Footer:myOrders'),
        to: CLIENT_PAGES.UNAVAILABLE.path,
        style: linkStyle
      },
      {
        text: i18next.t('Footer:myAddresses'),
        to: CLIENT_PAGES.UNAVAILABLE.path,
        style: linkStyle
      },
      {
        text: i18next.t('Footer:changePassword'),
        href: CLIENT_PAGES.UNAVAILABLE.path,
        style: linkStyle
      }
    ]
  }
];

export const FOOTER_LINKS_BY_COUNTRY = {
  default: FOOTER_LINKS_CL
};

const SOCIAL_LINKS_BY_COUNTRY = {
  default: [
    {
      iClassName: 'icon-facebook-full',
      id: 'facebook'
    },
    {
      iClassName: 'icon-twitter',
      id: 'twitter'
    },
    {
      iClassName: 'icon-instagram',
      id: 'instagram'
    },
    {
      iClassName: 'icon-tiktok',
      id: 'tiktok'
    },
    {
      iClassName: 'icon-youtube',
      id: 'youtube'
    },
    {
      iClassName: 'icon-tripadvisor',
      id: 'tripadvisor'
    }
  ]
};

const HOMEPAGE = {
  default: 'https://www.mercat.cl/?utm_source=tiendas&utm_medium=referral&utm_campaign=poweredby',
  cl: 'https://www.mercat.cl/?utm_source=tiendas&utm_medium=referral&utm_campaign=poweredby'
};

export const SOCIAL_LINKS = SOCIAL_LINKS_BY_COUNTRY.default;
export const FOOTER_LINKS = FOOTER_LINKS_BY_COUNTRY.default;
export const HOMEPAGE_LINKS = HOMEPAGE[ISO_COUNTRY] || HOMEPAGE.default;
